import * as React from "react";
import { BaseIcon, BaseIconProps } from "@/components/icons/primitives/BaseIcon";

/**
 * CoinGecko brand icon with full logo and colors
 *
 * Note: This icon includes hardcoded brand colors (#FFE866, #4BCC00, etc.)
 * and may not respond to currentColor styling like other icons.
 *
 * @example
 * ```tsx
 * // Basic usage
 * <CoinGeckoIcon size="md" />
 *
 * // With underlay
 * <CoinGeckoIcon
 *   size="lg"
 *   withUnderlay
 *   underlayClassName="bg-white"
 * />
 * ```
 */
export const CoinGeckoIcon = React.forwardRef<SVGSVGElement, Omit<BaseIconProps, "children">>((props, ref) => {
  return (
    <BaseIcon ref={ref} aria-label="CoinGecko" {...props}>
      <path
        d="M23.9998 12.0228C24.0298 18.6278 18.6814 24.0061 12.0545 24.036C5.42684 24.0659 0.0301276 18.7357 0.000125604 12.1305C-0.0298763 5.5255 5.31866 0.147205 11.9464 0.117305C18.5732 0.0883119 23.9698 5.41768 23.9998 12.0228Z"
        fill="#FFE866"
      />
      <path
        d="M18.0816 7.7976C17.2106 7.54662 16.3087 7.18965 15.3942 6.82995C15.3414 6.60162 15.1386 6.31712 14.7277 5.9683C14.1304 5.45184 13.0085 5.46544 12.0393 5.69376C10.9693 5.44279 9.91196 5.35309 8.89736 5.59591C0.600435 7.87464 5.30438 13.4314 2.25781 19.019C2.69148 19.935 7.47447 24.336 14.124 23.8473C14.124 23.8473 11.8121 18.3105 17.0297 15.6521C21.2618 13.4967 24.3192 9.49373 18.0807 7.79671L18.0816 7.7976Z"
        fill="#4BCC00"
      />
      <path
        d="M12.6246 9.13166C12.6246 10.4092 11.5855 11.4439 10.3045 11.4439C9.0235 11.4439 7.98438 10.4092 7.98438 9.13166C7.98438 7.85409 9.0235 6.82031 10.3045 6.82031C11.5855 6.82031 12.6246 7.85498 12.6246 9.13166Z"
        fill="white"
      />
      <path
        d="M20.9853 12.4628C19.1061 13.7829 16.9669 14.7841 13.9349 14.7841C12.5156 14.7841 12.2275 13.281 11.2892 14.0176C10.8047 14.3982 9.09729 15.2489 7.74174 15.1846C6.37436 15.1193 4.1915 14.3274 3.57782 11.4453C3.33508 14.3274 3.21143 16.4512 2.125 18.8849C4.79195 22.7632 9.44199 24.6928 14.1239 23.8536C13.6212 20.3536 16.6905 16.926 18.4197 15.1719C19.0743 14.5078 20.3289 13.4232 20.9853 12.4628Z"
        fill="#4BCC00"
      />
      <path
        d="M11.2677 11.0065C12.0197 11.0065 12.6292 10.1621 12.6292 9.12045C12.6292 8.0788 12.0197 7.23438 11.2677 7.23438C10.5158 7.23438 9.90625 8.0788 9.90625 9.12045C9.90625 10.1621 10.5158 11.0065 11.2677 11.0065Z"
        fill="#0D1217"
      />
      <path
        d="M11.8203 5.6869C12.5631 5.98068 15.2757 6.87468 16.4494 7.22561C15.251 5.25818 13.4351 5.37171 11.8203 5.6869Z"
        fill="#35AF00"
      />
      <path d="M11.2822 9.10904L9.64844 8.03125V10.1867L11.2822 9.10904Z" fill="white" />
    </BaseIcon>
  );
});

CoinGeckoIcon.displayName = "CoinGeckoIcon";
